import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import WhseJob1702Actions, { WhseJob1702Types } from '../Stores/WhseJob1702/Actions';

const getAppStore = state => state.app;

export function* whseJob1702FetchWhseJob1702({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(WhseJob1702Actions.whseJob1702FetchWhseJob1702Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexProcess/WHSE_JOB_17_02/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        WhseJob1702Actions.whseJob1702FetchWhseJob1702Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob1702Actions.whseJob1702FetchWhseJob1702Loading(false));
  }
}

export function* whseJob1702CreateWhseJob1702({ hdrIds }) {
  try {
    yield put(WhseJob1702Actions.whseJob1702CreateWhseJob1702Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `whseJob/createProcess/WHSE_JOB_17_02`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(WhseJob1702Actions.whseJob1702CreateWhseJob1702Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob1702Actions.whseJob1702CreateWhseJob1702Loading(false));
  }
}

export function* whseJob1702GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/binTrfDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(WhseJob1702Types.WHSE_JOB1702_GO_TO_DOCUMENT, whseJob1702GoToDocument),
  takeLatest(WhseJob1702Types.WHSE_JOB1702_FETCH_WHSE_JOB1702, whseJob1702FetchWhseJob1702),
  takeLatest(WhseJob1702Types.WHSE_JOB1702_CREATE_WHSE_JOB1702, whseJob1702CreateWhseJob1702)
];
